<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="weeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Truck container</small>
              </legend>
              <form @submit.prevent="loadTruckInterchange()">
                <div class="row">
                  <input type="hidden" class="truck_id" :value="Truck.id" />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control full_From_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control full_End_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary btn-flat creatingTruckInterchange">
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button type="button" class="btn btn-primary btn-flat creatingTruckInterchangeLoader">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal animated fadeIn"
      id="fullweeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Truck interchanges</small>
              </legend>
              <form @submit.prevent="loadContainerInterchange()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control From_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control End_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary btn-flat creatingContainerInterchange">
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button type="button" class="btn btn-primary btn-flat creatingContainerInterchangeLoader">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage transporters trucks</small>
      </legend>
      <button
        type="button"
        class="btn btn-success btn-roundec"
        data-toggle="modal"
        data-target="#fullweeklyexpensesModal"
      >
        <i class="fa fa-file-pdf-o"></i> General interchanges
      </button>
      <p></p>
      <div></div>
      <div>
        <div class="trucksLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading trucks...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemTrucks"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'faulty_status'">
              <span v-if="props.row.Faulty_status === 0">
                <button class="btn btn-info btn-sm btn-flat">
                  <i class="fa fa-level-up"></i> NOT FAULTY
                </button>
              </span>
              <span v-else-if="props.row.Faulty_status === 1">
                <button class="btn btn-danger btn-sm">
                  <i class="fa fa-level-down"></i> FAULTY
                </button>
              </span>
            </span>

            <span v-if="props.column.field == 'Action'">
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#weeklyexpensesModal"
                @click="viewTrucks(props.row.id)"
              >
                <i class="fa fa-file-pdf-o"></i> Truck interchanges
              </button>
            </span>
            <span v-else>{{props.formattedRow[props.column.field]}}</span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Transporter name",
          field: "transporter_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter transporter"
          }
        },
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number"
          }
        },
        {
          label: "Trailer number",
          field: "trailer_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter trailer no"
          }
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadTrucks();
  },
  computed: {
    ...mapGetters(["systemTrucks", "Truck"])
  },
  methods: {
    ...mapActions(["loadTrucks", "viewTrucks", "loadContainerInterchange", "loadTruckInterchange"])
  }
};
</script>
<style scoped>
.creatingContainerInterchangeLoader {
  display: none;
}
.creatingTruckInterchangeLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/reports/interchanges.vue